import axios from "axios";

/**
 * Pick the backend URL to call.
 *
 * In Emergent preview deployments the env var REACT_APP_BACKEND_URL is baked
 * into the bundle at build time, pointing at the preview host. When the same
 * bundle is served from a custom domain (e.g. cloudrentvps.com) the env URL
 * no longer matches the browser origin and any axios call becomes a cross-
 * origin request with `withCredentials: true`, which CloudFlare/our wildcard
 * CORS policy will block — leaving the UI silently empty.
 *
 * Fix: when the bundle is running in a browser, prefer the current window
 * origin so that all API calls stay same-origin via the /api ingress path.
 * In SSR / tests we fall back to the env value (or empty string for relative).
 */
function pickBackendUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL || "";
  if (typeof window === "undefined" || !window.location) return envUrl;
  if (!envUrl) return window.location.origin;
  try {
    const envOrigin = new URL(envUrl).origin;
    if (envOrigin !== window.location.origin) {
      return window.location.origin;
    }
    return envUrl;
  } catch {
    return window.location.origin;
  }
}

const BACKEND_URL = pickBackendUrl();
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Allow optional Bearer fallback if cookies are blocked.
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("access_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default api;

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" · ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
}
